import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';

import assistantTranslations from './translations';
import { TranslationOverrides } from './types';

// Create a dedicated i18n instance for the assistant package
const assistantI18n = createInstance();

assistantI18n.use(initReactI18next).init({
  lng: 'en-US',
  fallbackLng: 'en-US',
  debug: false,

  // Add our assistant translations directly to the instance
  resources: assistantTranslations,

  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },

  react: {
    useSuspense: false,
  },
});

/**
 * Update the assistant i18n instance with translation overrides
 *
 * @param overrides Translation overrides to merge with defaults
 */
export const updateAssistantTranslations = (overrides: TranslationOverrides = {}) => {
  // Deep merge translations with overrides
  const mergedResources: TranslationOverrides = { ...assistantTranslations };

  Object.keys(overrides).forEach((language) => {
    const existingResource = mergedResources[language];
    const overrideResource = overrides[language];

    if (existingResource && overrideResource) {
      // Deep merge existing language
      mergedResources[language] = {
        ...existingResource,
        assistant: {
          ...((existingResource.assistant as any) || {}),
          ...((overrideResource.assistant as any) || {}),
        },
      };
    } else if (overrideResource) {
      // Add new language
      mergedResources[language] = { ...overrideResource };
    }

    // Update the i18n instance — write to the 'assistant' namespace,
    // which is what components read via useTranslation('assistant', ...)
    const assistantContent = (mergedResources[language] as any)?.assistant;
    if (assistantContent) {
      assistantI18n.addResourceBundle(language, 'assistant', assistantContent, true, true);
    }
  });
};

export { assistantI18n as i18n };
export default assistantI18n;
